import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3121ab1f")

_pushScopeId("data-v-3121ab1f")
const _hoisted_1 = {
  key: 1,
  class: "text"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MaterialIcon = _resolveComponent("MaterialIcon")!

  return (_openBlock(), _createBlock("a", {
    class: "link",
    href: _ctx.href,
    title: _ctx.title,
    target: _ctx.isExternal ? '_blank' : '_self'
  }, [
    (_ctx.iconBefore)
      ? (_openBlock(), _createBlock(_component_MaterialIcon, {
          key: 0,
          class: "icon"
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.iconBefore), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.text)
      ? (_openBlock(), _createBlock("span", _hoisted_1, _toDisplayString(_ctx.text), 1))
      : _createCommentVNode("", true),
    (_ctx.iconAfter)
      ? (_openBlock(), _createBlock(_component_MaterialIcon, {
          key: 2,
          class: "icon"
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.iconAfter), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 8, ["href", "title", "target"]))
})